import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import AccountingYear from '../views/AccountingYear.vue'
import AddAccountingYear from '../views/AddAccountingYear.vue'
import ChartOfAccounts from '../views/ChartOfAccounts.vue'
import CashBank from '../views/CashBank.vue'
import Salaries from '../views/Salaries.vue'
import AddEmployee from '../views/AddEmployee.vue'
import UserManagement from '../views/UserManagement.vue'
import Expenses from '../views/Expenses.vue'
import AddExpense from '../views/AddExpense.vue'
import Payments from '../views/Payments.vue'
import Vendors from '../views/Vendors.vue'
import AddVendor from '../views/AddVendor.vue'
import Categories from '../views/Categories.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/accounting-years',
    name: 'AccountingYear',
    component: AccountingYear,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/accounting-years/new',
    name: 'AddAccountingYear',
    component: AddAccountingYear,
    meta: { requiresAuth: true }
  },
  {
    path: '/chart-of-accounts',
    name: 'ChartOfAccounts',
    component: ChartOfAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: '/cash-bank',
    name: 'CashBank',
    component: CashBank,
    meta: { requiresAuth: true }
  },
  {
    path: '/salaries',
    name: 'Salaries',
    component: Salaries,
    meta: { requiresAuth: true }
  },
  {
    path: '/salaries/employees/new',
    name: 'AddEmployee',
    component: AddEmployee,
    meta: { requiresAuth: true }
  },
  {
    path: '/salaries/employees/:partyId/edit',
    name: 'EditEmployee',
    component: AddEmployee,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/expenses',
    name: 'Expenses',
    component: Expenses,
    meta: { requiresAuth: true }
  },
  {
    path: '/add-expense',
    name: 'AddExpense',
    component: AddExpense,
    meta: { requiresAuth: true }
  },
  {
    path: '/payments',
    name: 'Payments',
    component: Payments,
    meta: { requiresAuth: true }
  },
   {
    path: '/vendors',
    name: 'Vendors',
    component: Vendors,
    meta: { requiresAuth: true }
   },
  {
    path: '/add-vendor',
    name: 'AddVendor',
    component: AddVendor,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'] || !!localStorage.getItem('token')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ path: '/', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      next({ path: '/dashboard' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
